import React, { InputHTMLAttributes, forwardRef } from 'react';
import '@cosmos/form/form.css';
import '@cosmos/form/input-default.css';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import clsx from 'clsx';

import styled from 'styled-components';

import { CustomIcon } from '../Icon';

const Wrapper = styled.div`
  & .icon {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  & input[type='time']::-webkit-calendar-picker-indicator {
    background: none;
  }
`;

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  icon?: IconDefinition;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, placeholder, className, icon, type = 'email', ...rest }, ref) => {
    return (
      <Wrapper className="hot-form">
        <label className="hot-form__label" htmlFor={`custom-input-${type}`}>
          {label}
        </label>
        <div className="_position-relative">
          {icon ? (
            <div tabIndex={-1}>
              <CustomIcon className="_text-gray-500 _position-absolute icon _mr-4" icon={icon} />
            </div>
          ) : null}
          <input
            {...rest}
            ref={ref}
            type={type}
            className={clsx(
              'hot-form__input hot-form__input--md _bg-transparent _text-gray-500',
              className
            )}
            id={`custom-input-${type}`}
            placeholder={placeholder}
          />
        </div>
      </Wrapper>
    );
  }
);

export default Input;
